/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ integration: NonNullable<unknown> }} Audit_Details_Api_Bridge_Write_Disabled_DescInputs */



/**
* | output |
* | --- |
* | "The {integration} integration's External API was set to read-only for the organisation." |
*
* @param {Audit_Details_Api_Bridge_Write_Disabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_api_bridge_write_disabled_desc = /** @type {((inputs: Audit_Details_Api_Bridge_Write_Disabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Api_Bridge_Write_Disabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die externe API der Integration ${i?.integration} wurde für die Organisation auf Nur-Lesen gestellt.`)
	return /** @type {LocalizedString} */ (`The ${i?.integration} integration's External API was set to read-only for the organisation.`)
});